<template>
  <div class="mt-2 flex items-center justify-start gap-2">
    <KikIcon
      icon="shipping_info_pdp"
      size="sm"
      class="place-content-center place-items-center place-self-center"
    />
    <p class="text-sm mobile:text-xs">
      {{ $t("Delivery in {deliveryTimeLabel} working days", { deliveryTimeLabel: $times.deliveryTimeLabel }) }} - {{ $t("Delivery only within {country}") }}
    </p>
  </div>
</template>

<script setup lang="ts">
const { $times } = useNuxtApp();
</script>
